// TODO COOCKIE
$(document).ready(function () {
  try {
    // window.addEventListener('unload', removeCookie);
  } catch (error) {
    window.attachEvent('onunload', removeCookie);
  }

  function getUrlParam (strHref) {
    var returnArray = {};
    if (!strHref)
      strHref = window.location.href;
    if (strHref.indexOf("?") > -1) {
      var strQueryString = strHref.substr(strHref.indexOf("?"));
      var aQueryString = strQueryString.split("&");
      aQueryString[0] = aQueryString[0].substring(1);
      for (var iParam = 0; iParam < aQueryString.length; iParam++) {
        var tmp = aQueryString[iParam].split("=");
        returnArray[unescape(tmp[0])] = unescape(tmp[1]);
        for (var z = 2; z < tmp.length; z++)
          returnArray[unescape(tmp[0])] += "=" + unescape(tmp[z]);
      }
    }
    return returnArray;
  }

	if(getUrlParam().type === "convy"){
		window.localStorage.setItem("UnycoChat_" + getUrlParam().version + "_" + getUrlParam().bot + "_" + getUrlParam().rnd , 'active');
	}else{
		window.localStorage.setItem("UnycoChat_" + getUrlParam().code + "_" + getUrlParam().rnd, 'active');
	}
});

function removeCookie() {
	if(this.getUrlParam().type === "convy"){
		window.localStorage.removeItem("UnycoChat_" + this.getUrlParam().version + "_" + this.getUrlParam().bot + "_" + this.getUrlParam().rnd);
	}else{
		window.localStorage.removeItem("UnycoChat_" + this.getUrlParam().code + "_" + this.getUrlParam().rnd);
	}
}

var bus = new Vue() // bus for comunicate events $emit to another components;
var appUnyco = new Vue({
  el: '#app-unyco',
  data: {
    debug: true,
    isloading: true,
    options: null,
    currentView: '', // set component view
    labelLang: null, // TODO Create instance UnycoChat for label.,
    relativePath: '',
    logLevel: {
      INFO: 'INFO',
      DEBUG: 'DEBUG',
      EVENT: 'EVENT',
      TRACE: 'TRACE',
      EXCEPTION: 'EXCEPTION'
    },
    typeForm: "",
  },
  components: {
    // <my-component> will only be available in parent's template
    //  'test-component': TestComponents
  },
  created: function () {
    this.getOptions();
    this.getLabel();

		if(this.getUrlParam().type === "convy"){
			this.options.internal.cookie.options.name = "wcs_unycochat_" + this.getUrlParam().version + "_" + this.getUrlParam().bot + "_" + this.getUrlParam().rnd;
		}else{
			this.options.internal.cookie.options.name = "wcs_unycochat_" + this.getUrlParam().code + "_" + this.getUrlParam().rnd;
		}

    bus.$on("onCobrowsingResponse", function (value) {
      if(this.options.internal.isConvy == false) {
        try {
          if (value && value.value) {
            this.openCobrowsing()
          } else {
            this.rejectCobrowsing()
          }
          this.$emit('hideCobrowsingPrompt');
        } catch (e) {
          this.rejectCobrowsing()
        }
      }
    }.bind(this));

    bus.$on("log-event", function (log) {
      if (!log.level || !this.logLevel[log.level]) log.level = this.logLevel.TRACE;
      if (!log.message) return;

      this.logger(log.level, log.message);
    }.bind(this))
  },
  methods: {
    getLabel: function () {
      this.labelLang = unycoLabels;
    },
    getOptions: function () {
      this.options = {
        lastUpdate: '20/01/2020',
        configuration: {
          demoMode: false,
          channel: 'chat',
          // channel: 'webcallback', //  for testing the webcallback page
          service: '',
          pathSwfCustom: null,
          allowVideoEscalation: false,
          allowAudioEscalation: false,
          allowEmailReservation: false,
          allowShareScreen: false,
          allowShareDoc: false,
          allowCloseSession: true,
          allowBackHistory: false,
          disableShareDoc: true,
          allowRepository: true,
          loadConfigurationButton: true, //false non vengono presi i valori in maniera dinamica
          customAttachedData: {},
          allowScreenSharingInstallation: true,
          showInitialForm: false,
          formDefinition: {},
          enableWebCallback: false,
          whenTriggerWebCB: [],
          callbackDefinition: {},
          timeFormat24h: true,
//					cobrowsing: {
//						url: null,
//						widget_key: null
//					}
        },
        internal: { //oggetto per contenere variabili di lavoro
          isConvy: false,
          gdpr: false,
          gdprChecked: false,
          isAnimationCompatibility: false,
          isEdge: false,
          retrieveSession: false,
          haveAlreadySessionActive: false,
          waitForAskSession: true,
          agentDisplayName: '', //ADD NEW VERSION
          isinitialized: false,
          isTransferred: false,
          backButton: 0,
          loadingDiv: '',
          loadingParent: '',
          msgBoxMargins: '',
          waitingGeoloc: false,
          geolocTimeout: 3000,
          bridge: null,
          gotSession: false,
          isTransferring: false,
          activeContact: false,
          requestCloseFromCustomer: false,
          requestCloseReason: null,
          escalationType: null,
          isMobile: false,
          flashInstalled: false,
          webrtcAvailable: false,
          agentWebrtcAvailable: false,
          isComposing: false,
          timerIsComposing: null,
          sessionRequestTimeout: 60000,
          sessionRequestTimer: null,
          sendTrueIsComposing: false,
          sessionData: {},
          emailKeyRegexp: /^e?mail/i,
          emailValidationRegexp: /^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,4}$/i,
          workingHours: {},
          olsonName: '',
          timezone: '',
          onlyWebCB: false,
          // onlyWebCB: true,    //  for testing webcallback form
          form: {
            initial: {}
          },
          session: {
            chat: false,
            close: false
          },
          writeWelcome: true,
          agentErrorReason: null,
          customerInfo: {},
          notAllowedExtensions: ['msi', 'exe', 'js', 'jse', 'com', 'pif', 'bat', 'scr', 'jar', 'reg', 'msc', 'dll', 'cmd', 'vb', 'vbs', 'vbe', 'application', 'gadget', 'msp', 'com', 'hta'],
          allowedExtensions: null, //il default a null vuol dire che se è vuoto, per retrocompatibilita allora tutte le estensioni sono valide a patto che non siano nell'array sopra
          showOpeningHoursForInfo: false,
          enabledGeoloc: false,
          viewAgentName: true,
          maxAllowedMessageSize: 1000,
          maxAllowedInitialFormSize: 255,
          waitingAgent: false,
          waitForPluginInstallation: false,
          webrtcScreenSharingEnabled: false,
          webrtcScreenSharingReady: false,
          webrtcScreenSharingSupported: false,
          webrtcScreensharingUrl: null,
          mustAskSession: false,
          canAskSession: false,
          endChat: false,
          history: {
            config: {
              start: 0,
              end: 0,
              rangeMessageToLoad: 10,
              firstMessages: true,
              skipScrollMessage: false
            },
            messages: null
          },
          isCalling: false,
          isExpand: false,
          waitForPluginInstallationCookie: false,
          minimizeOnCloseSession: true,
          isAgentError: false,
          cookie: {
            options: {
              valididty: 1,
              name: 'wcs_unycochat',
              secret: 'wcs_cookie_string'
            },
            props: {
              popoverstatus: 'popoverstatus',
              cogitosearchstatus: 'cogitosearchstatus',
              cogitourlopen: 'cogitourlopen',
              channel: 'channel'
            },
            obj: {}
          },
          isSessionTransferError: false,
          agentBubbleColours: [
            "#d7e8f4",
            "#ffcab180", //arancione
            "#e8ffb7c2", //giallo
            "#baeaddc7",  //verde
            "#ecb0e18c", //rosa
            "#beb8e878" //viola
          ],
          currentIndexColour: 0,
          agentBubbleColoursMap: {},
          cobrowsingSession: null,
        },
        flag: {
          log: true
        },
        ConvyEvent: {
          SYSTEM_CONVY_EVENT_BACK: "SYSTEM_CONVY_EVENT_BACK",
          SYSTEM_CONVY_FORM_SUBMIT: "SYSTEM_CONVY_FORM_SUBMIT",
          SYSTEM_CONVY_FORM_SKIP: "SYSTEM_CONVY_FORM_SKIP",
          SYSTEM_CONVY_BUTTONS_SUBMIT: "SYSTEM_CONVY_BUTTONS_SUBMIT"
        },
        CogitoSearchStatus: {
          EXPANDED:'expanded',
          MINIMIZED: 'minimized',
          DESTROYED: 'destroyed',
        },
        PopoverStatus: {
          EXPANDED: 'expanded',
          MINIMIZED: 'minimized'
        },
        ExternalCommands: {
          EXPAND: 'expand',
          COLLAPSE: 'collapse',
          BLINK: 'blink',
          REFRESHIFRAME: 'refreshiframe',
          ACTIVECHAT: 'activechat',
          NOTACTIVECHAT: 'notactivechat',
          READY: 'ready',
          SCROLLCHAT: 'scrollchat',
          ENDSCROLLCHAT: 'endscrollchat',
          CLOSESESSION: 'closesession',
          DEBUGINFO: 'debuginfo',
          SEND_EVENT: 'SEND_EVENT',
          SEND_VOICE_MESSAGE: 'SEND_VOICE_MESSAGE',
          COGITO_SEARCH: 'COGITO_SEARCH'
        },
        cogitoSearchAction: {
          EXPAND: 'EXPAND',
          COLLAPSE: 'COLLAPSE',
          HIDE: 'HIDE',
          PAGE: 'PAGE'
        },
        InterfaceMode: {
          POPOVER: 'popover',
          POPUP: 'popup'
        },
        navigationMap: [],
        imgCustomer: '../img/customer.svg',
        imgAgent: '../img/support.svg',
        imgFailCustomer: '../img/customer.png',
        imgFailAgent: '../img/agent.png',
        logo: '../img/logo.png',
        imgVirtualAgent: '../img/MrCredit_virtual.png',
        imgFailVirtualAgent: '../img/MrCredit_virtual.png',
        largeNameHeader: false,
        rainbowHeader: false,
        isVirtualAgent: false,
        fullPageMode: false,
				headerLogo: false,
        isFromLink: false,
        bgFullPage: "#ccc",
        isAsyncChat: false,
        inPause: false,
        buttonCallBackVisible: true,
        isChatOnlyAudio: false,
        isChatOnlyVideo: false,
        pos: {
          lat: null,
          lng: null,
        },
        errorGeolation: '',
        supportGeolocation: null

      }
    },
    computed: {
      getAgentName: function () {
        return this.options.internal.agentDisplayName;
      }

    },
    onBridgeInclusionError: function () {
      this.logger(this.logLevel.INFO, "Error loading EuBridge");
    },

    start: function () {


      if (this.getUrlParam().type === "convy") {
        this.options.internal.isConvy = true;
        this.options.imgAgent = this.options.imgVirtualAgent;
        this.options.imgFailAgent = this.options.imgFailVirtualAgent;
        this.options.largeNameHeader = true;
        this.options.isRainbowHeader = true;
      }
      if (this.getUrlParam().fullPage) {
        if (this.getUrlParam().fullPage === "true") {
          this.options.fullPageMode = true;
          document.body.style.background = this.options.bgFullPage;
        }
      }

      //anziche l'immagine agente con il nome si può mettere il logo di convy (COGITO SEARCH)
      if(this.getUrlParam().headerLogo) {
      	if(this.getUrlParam().headerLogo === "true"){
      		this.options.headerLogo = true;
				}
			}

      if (typeof EuBridge === "undefined") {
        try {
          var js = document.createElement("script");
          js.type = "text/javascript";
          js.onload = this.onBridgeIncluded.bind(this);
          js.onerror = this.onBridgeInclusionError.bind(this);
          if (!this.options.internal.isConvy) {
            this.relativePath = this.getUrlParam().relativePath || '';
            js.src = this.relativePath + "/SessionHandler/js/EuBridgeSDK.js";
          } else {
            this.relativePath = this.getUrlParam().relativePath || '';
            js.src = this.relativePath + "/static/include/v2/EuBridgeSDK.js";
          }
          if (document.head)
            document.head.appendChild(js);
          else
            document.getElementsByTagName('head')[0].appendChild(js);
        } catch (e) {
          this.onBridgeInclusionError();
        }
      } else {
        this.onBridgeIncluded();
      }
    },
    onBridgeIncluded: function () {
      this.logger(this.logLevel.INFO, "start");
      //this.options.internal.isMobile=$.browser.mobile; // TODO browser.mobile
      var debugEnabled = this.getUrlParam().debug == "true" || (window.location.href.indexOf("debug=true") != -1);
      this.debug = debugEnabled;
      if (this.isAsyncChat) {
        this.options.internal.bridge = EuBridge.getInstance("V2");
      } else {
        this.options.internal.bridge = EuBridge.getInstance(debugEnabled);
      }

      this.options.internal.bridge.initialize(this.relativePath, this.bridgeInitialized.bind(this), this.bridgeInitError.bind(this), this.bridgeInitOptions());
      this.options.internal.bridge.setConfigurations({
        tooltipEnabled: true,
        label: this.labelLang.configurations
      });
      if (this.options.internal.isConvy) {
        this.options.configuration.disableShareDoc = true;
        this.options.configuration.allowEmailReservation = false;
        this.options.configuration.allowRepository = false;

      }
    },
    customInitForMobile: function () {
      if (!this.options.internal.flashInstalled && !this.options.internal.webrtcAvailable) {
        this.options.configuration.allowVideoEscalation = false;
        this.options.configuration.allowAudioEscalation = false;
      }
      this.options.configuration.allowShareScreen = false;
    },
    bridgeInitialized: function (e) {

      this.setPopoverListener();
      this.blockScrollParentFrame();
      this.options.internal.flashInstalled = e.flashInstalled;

      if (this.options.internal.isMobile) {
        this.customInitForMobile();
      }
      this.registerBridgeEvents();
    },
    getBool: function (val) {
      return !!JSON.parse(String(val).toLowerCase());
    },
    bridgeInitOptions: function () {
      if (this.getUrlParam().gdpr && this.getUrlParam().gdpr == "true" || this.getUrlParam().gdpr == "false") {
        this.options.internal.gdpr = this.getBool(this.getUrlParam().gdpr);
      }

      if (this.getUrlParam().fromLink && this.getUrlParam().fromLink == "true") {
        this.options.isFromLink = true;
      }


      var opts = {
        mode: this.isPopoverMode() ? this.options.InterfaceMode.POPOVER : this.options.InterfaceMode.POPUP
      };
      var bridgeType = this.getUrlParam().type;
      if (this.options.internal.isConvy && typeof customConfiguration !== "undefined" && customConfiguration.convy) {
        opts["convy"] = {
          name: customConfiguration.convy.name || 'Bot'
        };
        if (customConfiguration.convy.composing) {
          opts["convy"].composing = customConfiguration.convy.composing;
        }
        if (customConfiguration.convy.debug) {
          opts["convy"].debug = customConfiguration.convy.debug;
        }
      }
      return opts;
    },
    bridgeInitError: function () {
      this.showBlockingError(this.labelLang.initError);
    },
    beforeunload: function () {
      this.options.internal.bridge.sendComposing(false);
    },
    detectIEbeforeEdge: function () {
      if (/MSIE 9/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
        this.options.internal.isAnimationCompatibility = false;
      } else if (/Edge\/\d./i.test(navigator.userAgent)) {
        this.options.internal.isEdge = true;
        this.options.internal.isAnimationCompatibility = true;
      } else {
        this.options.internal.isAnimationCompatibility = true;
      }
      try {
        const vendor = window.navigator.vendor;
        const isChromium = window.chrome;
        if (vendor && vendor === "Google Inc." && isChromium) {
          this.options.internal.isAnimationCompatibility = false;
        }
      } catch (e) {}
    },

    /* * * COBROWSING HANDLING * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    handleCobrowsingRequest: function () {
      if(this.options.internal.isConvy == false) {
        this.promptCobrowsing();
      }
    },

    raiseCobrowsingEventMessage: function (event) {
      this.$emit("onSystemMsg", this.labelLang[event] || event);
    },

    promptCobrowsing: function () {
      if (this.getUrlParam().autoCobrowsing == "true") {
        // Start the cobrowsing automatically
        bus.$emit('onCobrowsingResponse', { value: true, id: "" });
      } else {
        this.$emit("showCobrowsingPrompt", {
          title: this.labelLang.cobrowsing_request_prompt,
          choices: [
            { text: this.labelLang.cobrowsing_request_prompt_reject, value: false },
            { text: this.labelLang.cobrowsing_request_prompt_accept, value: true }
          ]
        });
      }
    },

    rejectCobrowsing: function () {
      this.options.internal.bridge.rejectCobrowsing();
      this.$emit("hideCobrowsingPrompt");
      this.raiseCobrowsingEventMessage("cobrowsing_rejected")
    },

    openCobrowsing: function () {
      this.options.internal.bridge.openCobrowsing();
    },

    cobrowsingAccepted: function() {
      this.raiseCobrowsingEventMessage("cobrowsing_accepted");
    },

    cobrowsingStarted: function() {
      this.raiseCobrowsingEventMessage("cobrowsing_started");
    },

    cobrowsingEnded: function() {
      // hide cobrowsing prompt just in case the event comes
      // before the customer accepts or rejects the cobrowsing request
      this.$emit("hideCobrowsingPrompt");
      this.raiseCobrowsingEventMessage("cobrowsing_ended");
    },

    cobrowsingError: function(error) {
      this.$emit("hideCobrowsingPrompt");
      this.raiseCobrowsingEventMessage("cobrowsing_error");
      this.logger(this.logLevel.EXCEPTION, "Received error from Cobrowsing Session: " + JSON.stringify(error))
    },

    closeCobrowsing: function () {
      this.options.internal.bridge.closeCobrowsing();
      this.$emit('hideCobrowsingPrompt');
    },

    pauseCobrowsing: function () {
      this.options.internal.bridge.pauseCobrowsing();
    },

    resumeCobrowsing: function () {
      this.options.internal.bridge.resumeCobrowsing();
    },

    cobrowsingRequestWithdraw: function () {
      this.$emit("hideCobrowsingPrompt");
      this.raiseCobrowsingEventMessage("cobrowsing_request_withdraw");
    },

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    beforeInit: function () {
      this.logger(this.logLevel.INFO, "before Init");
      this.detectIEbeforeEdge();

      if (this.options.isFromLink) {
        this.requestServiceConfiguration();
      }

      if (this.options.internal.bridge.retrieveSession()) {
        this.logger(this.logLevel.INFO, "session retrieveSession ok");
        this.options.internal.haveAlreadySessionActive = true;
        this.options.internal.retrieveSession = true;
      } else {
        this.options.internal.haveAlreadySessionActive = false;
        this.options.internal.retrieveSession = false;
        this.options.internal.waitForAskSession = false;
        this.logger(this.logLevel.INFO, "no session retrieveSession");
        this.options.configuration.service = this.getUrlParam().code;

			}
			if(this.getUrlParam().type === "convy"){
				this.sendMessageToParent({ command: this.options.ExternalCommands.READY, session: this.parseBoolean(localStorage.getItem('unycoFirstVisit_' + this.getUrlParam().version + "_" + this.getUrlParam().bot + "_" + this.getUrlParam().rnd)) });
				localStorage.setItem('unycoFirstVisit_' + this.getUrlParam().version + "_" + this.getUrlParam().bot + "_" + this.getUrlParam().rnd , 'active', 'false');
			}else{
				this.sendMessageToParent({ command: this.options.ExternalCommands.READY, session: this.parseBoolean(localStorage.getItem('unycoFirstVisit_' + this.getUrlParam().code + "_" + this.getUrlParam().rnd)) });
				localStorage.setItem('unycoFirstVisit_' + this.getUrlParam().code + "_" + this.getUrlParam().rnd, 'false');
			}
		},
		deviceWaiting: function () {
			var s = this.labelLang.deviceWaiting;
			this.appendSystemMsg('block', 'warning_device');
		},
		deviceWaitingRemove: function () {
			//	$('[data-selector="warning_device"]').parent('.messagesent').remove(); // TODO warning_device
		},
		registerBridgeEvents: function () {

      this.options.internal.bridge.addEventListener(EuBridge.EventType.screen_sharing_support, this.extensionScreenSharingAvailable.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.configuration_loaded, this.configurationLoaded.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.configuration_not_found, this.bridgeInitError.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_created, this.sessionCreated.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_denied, this.sessionDenied.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_closed, this.sessionClosed.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_expired, this.sessionExpired.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_retrieved, this.sessionRetrieved.bind(this));
      if (EuBridge.EventType.session_restarted) {
        this.options.internal.bridge.addEventListener(EuBridge.EventType.session_restarted, this.sessionRestarted.bind(this));
      }
      this.options.internal.bridge.addEventListener(EuBridge.EventType.request_agent_completed, this.agentSelected.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.request_agent_failed, this.agentError.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.contact_closed, this.contactClosed.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.welcome_message, this.welcomeMessage.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.message_received, this.msgReceived.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.user_message, this.userMsgSent.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.user_event, this.userEventSent.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.chat_state_received, this.chatStateChanged.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.link_received, this.incomingLink.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.document_received, this.incomingDocument.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_paused, this.sessionPaused.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_resumed, this.sessionResumed.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_transfer, this.sessionTransferStart.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_transfer_done, this.sessionTransferEnd.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_transfer_failed, this.sessionTransferError.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.server_unavailable, this.sessionError.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_already_created, this.sessionError.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.session_error, this.sessionError.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.escalation_result, this.escalationResult.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.call_event, this.callEvent.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.recorder_event, this.recordingEvent.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.downgrade_audio_done, this.downgradeToAudioDone.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.device_waiting, this.deviceWaiting.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.device_acquired, this.deviceWaitingRemove.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.webrtc_plugin_not_installed, this.webrtcNotInstalled.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.incoming_agent_screen_sharing_request, this.handleIncomingScreenSharing.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.agent_screen_sharing_stopped, this.handleIncomingScreenSharing.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.agent_screen_sharing_stream_suspended, this.handleIncomingScreenSharing.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.incoming_screen_sharing_viewer_closed, this.incomingScreenSharingAccepted.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.document_sent, this.documentSent.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.document_send_failed, this.documentSendFailed.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.document_size_exceeded, this.documentSizeExceeded.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.document_extension_not_allowed, this.documentExtensionNotAllowed.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.document_send_disabled, $.proxy(this.disableShareDocButton, this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.document_send_enabled, $.proxy(this.enableShareDocButton, this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.callback_request_added, function () { }.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.custom_command_received, this.customCommandReceived.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.replace_message_placeholders, this.replaceMessagePlaceholders.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.response_working_hours, this.responseWorkingHours.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.system_message, this.systemMessageReceived.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.rainbow_webrtc_message, this.rainbowWebrtcMessage.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.call_running, this.webrtc2sipHandler.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.call_ringing, this.webrtc2sipHandler.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.call_queued, this.webrtc2sipHandler.bind(this));

      // COBROWSING EVENTS
      this.options.internal.bridge.addEventListener(EuBridge.EventType.cobrowsing_request, this.handleCobrowsingRequest.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.cobrowsing_accepted, this.cobrowsingAccepted.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.cobrowsing_started, this.cobrowsingStarted.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.cobrowsing_ended, this.cobrowsingEnded.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.cobrowsing_error, this.cobrowsingError.bind(this));
      this.options.internal.bridge.addEventListener(EuBridge.EventType.cobrowsing_request_withdraw, this.cobrowsingRequestWithdraw.bind(this));

      if (this.getUrlParam().type === "convy" && this.getUrlParam().debug === "true") {
        this.options.internal.bridge.addEventListener(EuBridge.EventType.debug_info, this.onDebugInfo.bind(this));
      }  else {
        // WCS specific events
        this.options.internal.bridge.addEventListener(EuBridge.EventType.video_stream_switched, this.onVideoStreamSwitched.bind(this));
      }
      this.beforeInit();
    },

    onVideoStreamSwitched: function(e) {
      this.$emit('onVideoStreamSwitched', e);
    },

    onDebugInfo: function (e) {
      this.sendMessageToParent({ command: this.options.ExternalCommands.DEBUGINFO, info: e.info });
    },
    systemMessageReceived: function (e) {
      var m = this.messages || this.labelLang;
      switch (e.action) {
        case "agentJoinConversation":
          if (!this.options.internal.agentBubbleColoursMap[e.agentName]) {
            this.options.internal.agentBubbleColoursMap[e.agentName] = this.options.internal.agentBubbleColours[this.options.internal.currentIndexColour];
            if (this.options.internal.currentIndexColour == this.options.internal.agentBubbleColours.length - 1) {
              this.options.internal.currentIndexColour = 0;
            } else {
              this.options.internal.currentIndexColour++;
            }
          }
          this.appendSystemMsg('info', m[e.action].replace('%agentName%', e.agentName));
          break;
        case "agentLeaveConversation":
          this.options.internal.agentBubbleColoursMap.remove(e.agentName);
          this.appendSystemMsg('info', m[e.action].replace('%agentName%', e.agentName));
          break;
        case "voice_message":
          this.appendSystemMsg('info', m[e.action]);
          break;
        case "voice_message_fail":
          this.appendSystemMsg('info', m[e.action]);
          break;
        case "wcs_handover_terminated":
          this.options.isVirtualAgent = true;
          this.options.imgAgent = "";
          this.options.internal.agentDisplayName = "ConvyAI";
          break;
        case "wcs_handover_queue":
          bus.$emit("onInputMsgDisabled", true);
          // setTimeout(function () {
          //   this.appendSystemMsg('info', m[e.action]);
          // }.bind(this), 2000);
          this.$emit("onComposingAgent", false);
          break;
        case "wcs_handover_connected":
          bus.$emit("onInputMsgDisabled", false);
          //this.appendSystemMsg('info', m[e.action].replace('%agentName%', e.agentName));
          this.options.isVirtualAgent = false;
          this.options.imgAgent = '../img/support.svg';
          this.options.internal.agentDisplayName = e.agentName;
          this.enableShareDocButton();
          this.$emit("onComposingAgent", false);
          break;
        case "wcs_handover_transferring":
          bus.$emit("onInputMsgDisabled", true);
          this.options.internal.agentDisplayName = m[e.action];
          this.disableShareDocButton();
          this.$emit("onComposingAgent", false);
          break;
      }
    },

    setPopoverListener: function () {
      window.addEventListener('message', $.proxy(this.receiveMessage, this), false);
      window.onbeforeunload = $.proxy(this.beforeunload, this);
      /* controllare lo stato di expanded?? -> controllo non lo faccio subito
      Dipende se devo fare un session retrieve e quindi faccio il controllo,
      altrimenti in caso di sessionexpire non devo nemmeno fare un controllo
      perchè la chat è chiusa */
    },
    blockScrollParentFrame: function () {
      var that = this;
      var elementsScrollApp = document.getElementById("app-unyco");

      window.onwheel = function () {
        //  handleScroll()
        that.sendMessageToParent({ command: that.options.ExternalCommands.SCROLLCHAT });

      }
      if (elementsScrollApp) {
        elementsScrollApp.addEventListener("mouseover", function (event) {
          that.sendMessageToParent({ command: that.options.ExternalCommands.ENDSCROLLCHAT });
        });
      }

    },
    setChatStatus: function () {
      if (this.options.internal.haveAlreadySessionActive) {
        this.sendMessageToParent({ command: this.options.ExternalCommands.ACTIVECHAT });
      } else {
        this.sendMessageToParent({ command: this.options.ExternalCommands.NOTACTIVECHAT });
      }
    },
    checkCogitoSearchIframe: function() {
      var cogitosearchstatus = this.getSessionCookie(this.options.internal.cookie.props.cogitosearchstatus);
      if(cogitosearchstatus === this.options.CogitoSearchStatus.EXPANDED){
        var cogitourl = this.getSessionCookie(this.options.internal.cookie.props.cogitourlopen);
        this.sendMessageToParent({ command: this.options.ExternalCommands.COGITO_SEARCH, action: this.options.cogitoSearchAction.EXPAND, url: cogitourl });
      }
      if(cogitosearchstatus === this.options.CogitoSearchStatus.MINIMIZED){
        var cogitourl = this.getSessionCookie(this.options.internal.cookie.props.cogitourlopen);
        this.sendMessageToParent({ command: this.options.ExternalCommands.COGITO_SEARCH, action: this.options.cogitoSearchAction.COLLAPSE, url: cogitourl });
      }
      if(cogitosearchstatus === this.options.CogitoSearchStatus.DESTROYED){
        this.sendMessageToParent({ command: this.options.ExternalCommands.COGITO_SEARCH, action: this.options.cogitoSearchAction.HIDE });
      }
    },
    expandChat: function () {
      bus.$emit('expandChat', true);
      this.setChatStatus();
      this.options.internal.isExpand = true;
      this.createSessionCookie(this.options.internal.cookie.props.popoverstatus, this.options.PopoverStatus.EXPANDED);
      if (!this.options.internal.waitForAskSession && !this.options.internal.isAgentError) {	// TODO: Check if the session routing has failed
        this.requestServiceConfiguration();
      }
      if(this.options.internal.haveAlreadySessionActive){
        //COGITOSEARCH
        this.checkCogitoSearchIframe();
        bus.$emit('onUpdateScroll');
      }else{
        //COGITOSEARCH
        this.createSessionCookie(this.options.internal.cookie.props.cogitosearchstatus, this.options.CogitoSearchStatus.DESTROYED);
        this.createSessionCookie(this.options.internal.cookie.props.cogitourlopen, "");
      }
      //Se lo sharing non è disabilitato, mostro la graffetta (altrimenti dopo un minimize e restore non la si vede più)
      if (!this.options.configuration.disableShareDoc){
				this.options.configuration.disableShareDoc = false;
				this.options.configuration.allowShareDoc = true;
				this.$emit('onDocEnable');
      }
    },
    collapseChat: function () {
      this.setChatStatus();
      this.createSessionCookie(this.options.internal.cookie.props.popoverstatus, this.options.PopoverStatus.MINIMIZED);
      this.options.internal.isExpand = false;
    },
    receiveMessage: function (evt) {
      var that = this
      if (!evt.data.command == "endscrollchat" || !evt.data.command == "scrollchat") {
        this.logger(this.logLevel.INFO, "Message received. Command ==> " + evt.data.command);
      }

      if (evt.data.command == "ready" && this.options.isFromLink) {
        this.expandChat();
      }

      switch (evt.data.command) {
        case this.options.ExternalCommands.EXPAND:
          this.expandChat();
          break;
        case this.options.ExternalCommands.COLLAPSE:
          this.collapseChat();
          break;
        case this.options.ExternalCommands.CLOSESESSION:
          this.closeSession();
          break;
        case this.options.ExternalCommands.SEND_EVENT:
          this.sendEvent(evt.data.data.eventName, evt.data.data.parameters);
          break;
        case this.options.ExternalCommands.SEND_VOICE_MESSAGE:
          //mostrare il messaggio di messaggio di sistema che l'audio è stato inviato
          this.$emit('clearLastMenu');
          this.systemMessageReceived(evt.data);
          break;
        //COGITOSEARCH
        case this.options.ExternalCommands.COGITO_SEARCH:
          switch(evt.data.action){
            case this.options.cogitoSearchAction.EXPAND:
              this.createSessionCookie(this.options.internal.cookie.props.cogitosearchstatus, this.options.CogitoSearchStatus.EXPANDED);
              break;
            case this.options.cogitoSearchAction.COLLAPSE:
              this.createSessionCookie(this.options.internal.cookie.props.cogitosearchstatus, this.options.CogitoSearchStatus.MINIMIZED);
              break;
            case this.options.cogitoSearchAction.HIDE:
              break;
          }
          break;
      }
    },
    callWebCallback: function () {
      this.agentError({
        reason: 'webcallbackOnly',
        working_hours: {},
        olsonName: null,
        timezone: null
      });
    },
    callAgent: function () {
      this.logger(this.logLevel.INFO, "Request agent on service " + this.options.configuration.service + " for channel " + this.options.configuration.channel);
      this.$emit('onMsgLoading', this.labelLang.queue);

      if (this.options.configuration.channel != 'chat') {
        this.options.internal.writeWelcome = false;
      }

      this.options.internal.bridge.requestAgent(this.options.configuration.channel, this.options.configuration.service); // call Agente // callback Agent Complete
    },

    sessionCreated: function (e) {
      this.logger(this.logLevel.INFO, "session created:");
      bus.$emit('showRestartButton', true);
      this.options.internal.endChat = false;
      this.options.internal.haveAlreadySessionActive = true;
      this.sendMessageToParent({ command: this.options.ExternalCommands.ACTIVECHAT });
      if (this.options.internal.onlyWebCB) {
        clearTimeout(this.options.internal.sessionRequestTimer); // TODO rework
        this.callWebCallback();
      } else {
        if (!this.options.internal.retrieveSession) {
          // Is the start of a new session
          clearTimeout(this.options.internal.sessionRequestTimer); // TODO rework
          this.callAgent();
        }
      }
    },
    extensionScreenSharingAvailable: function (e) {
      this.logger(this.logLevel.INFO, "extensionScreenSharingAvailable");

      this.options.internal.webrtcScreensharing = true;
      this.options.internal.webrtcScreenSharingReady = this.parseBoolean(e.ready); //ready true|false true è pronto ad andare avanti | false no, mostro landing page
      this.options.internal.webrtcScreenSharingEnabled = this.parseBoolean(e.available); //available true|false  true screen sharing webrtc | false non webrtc
      this.options.internal.webrtcScreenSharingSupported = this.parseBoolean(e.screen_sharing_type == 'extension'); //screen sharing typology
      this.options.internal.webrtcScreenSharingType = e.screen_sharing_type;
      if (e.hasOwnProperty('url')) {
        this.options.internal.webrtcScreensharingUrl = e.url;
      }

      if (this.options.internal.webrtcScreenSharingEnabled && this.options.internal.webrtcScreenSharingSupported && !this.options.internal.webrtcScreenSharingReady && this.options.internal.webrtcScreensharingUrl) {
        this.firefoxXpiNotInstalled(e.url);
      }

    },

    parseBoolean: function (str) {
      return /^true$/i.test(str);
    },
    firefoxXpiNotInstalled: function (url) {
      var optionsPanel = {
        'url': url,
        'plugin': 'addon',
        'install_for_video': this.labelLang.plugin_addon_install_for_video,
        'install_for_screensharing': this.labelLang.plugin_addon_install_for_screensharing,
        'installnow': this.labelLang.plugin_addon_installnow,
        'nothanks': this.labelLang.plugin_addon_installnow_nothanks,
        'cancel': this.labelLang.plugin_addon_installnow_cancel,
        'download': this.labelLang.plugin_addon_installnow_download,
        'waiting': this.labelLang.plugin_addon_waiting,
      }
      this.$emit('onPanelPlugin', true);
      this.$emit('onPanelOption', optionsPanel);
    },
    webrtcNotInstalled: function (e) {
      var url = e.url;
      var optionsPanel = {
        'url': url,
        'plugin': 'temasys',
        'install_for_video': this.labelLang.plugin_temasys_install_for_video,
        'install_for_screensharing': this.labelLang.plugin_temasys_install_for_screensharing,
        'installnow': this.labelLang.plugin_temasys_installnow,
        'nothanks': this.labelLang.plugin_temasys_installnow_nothanks,
        'cancel': this.labelLang.plugin_temasys_installnow_cancel,
        'download': this.labelLang.plugin_temasys_installnow_download,
        'waiting': this.labelLang.plugin_temasys_waiting,
      }

      this.$emit('onPanelPlugin', true);
      this.$emit('onPanelOption', optionsPanel);

    },
    isPopoverMode: function () {
      var isPopOver;
      var param = this.getUrlParam().mode && this.getUrlParam().mode.toLowerCase().indexOf('popover') !== -1;
      if (param) {
        isPopOver = param;
      } else {
        isPopOver = false
      }

      if (isPopOver == true) {
        this.$emit('onPopOver', true);
      }

      return isPopOver;
    },
    logger: function (level, text) {
      try {
        var data = new Date();

        if (typeof text == 'object' && level != this.logLevel.EXCEPTION) {
          text = JSON.stringify(text, undefined, 2);
        }
        var log = data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds() + ':' + data.getMilliseconds() + ' - ' + level + ' : ' + text;
        if (typeof console == 'object') {
          if (this.debug) {
            try {
              console.log('%c' + log, this.logStyle(level));
              if (level == this.logLevel.EXCEPTION) {
                console.error(text.stack);
              }
            } catch (e) {
              console.log(log);
            }
          }

        }
      } catch (e) { }
    },
    logStyle: function (level) {
      switch (level) {
        case "INFO":
          return "color:#428bca;";
        case "DEBUG":
          return "background-color:black;color:green";
        case "TRACE":
          return "color:black";
      }
    },

    getUrlParam: function (strHref) {
      var returnArray = {};
      if (!strHref)
        strHref = window.location.href;
      if (strHref.indexOf("?") > -1) {
        var strQueryString = strHref.substr(strHref.indexOf("?"));
        var aQueryString = strQueryString.split("&");
        aQueryString[0] = aQueryString[0].substring(1);
        for (var iParam = 0; iParam < aQueryString.length; iParam++) {
          var tmp = aQueryString[iParam].split("=");
          if (unescape(tmp[0]) == 'channel') {
            this.options.configuration.channel = this.options.internal.start_channel = unescape(tmp[1]);
          }
          returnArray[unescape(tmp[0])] = unescape(tmp[1]);
          for (var z = 2; z < tmp.length; z++)
            returnArray[unescape(tmp[0])] += "=" + unescape(tmp[z]);
        }
      }
      return returnArray;
    },
    getTime: function () {
      var now = new Date();
      if (this.options.configuration.timeFormat24h)
        //    return now.getHours() + ':' + ((now.getMinutes() < 10) ? "0" : "") + now.getMinutes() + ':' + ((now.getSeconds() < 10) ? "0" : "") + now.getSeconds();
        return now.getHours() + ':' + ((now.getMinutes() < 10) ? "0" : "") + now.getMinutes();

      else
        return ((now.getHours() < 10) ? "0" : "") + ((now.getHours() > 12) ? (now.getHours() - 12) : now.getHours()) + ":" +
          ((now.getMinutes() < 10) ? "0" : "") + now.getMinutes() + ":" +
          //    ((now.getSeconds() < 10) ? "0" : "") + now.getSeconds() +
          ((now.getHours() > 12) ? ('PM') : 'AM');
    },
    getTimeFromTimestamp: function (timestamp) {
      var now = new Date(timestamp);
      if (this.options.configuration.timeFormat24h)
        //  return now.getHours() + ':' + ((now.getMinutes() < 10) ? "0" : "") + now.getMinutes() + ':' + ((now.getSeconds() < 10) ? "0" : "") + now.getSeconds();
        return now.getHours() + ':' + ((now.getMinutes() < 10) ? "0" : "") + now.getMinutes()

      else
        return ((now.getHours() < 10) ? "0" : "") + ((now.getHours() > 12) ? (now.getHours() - 12) : now.getHours()) + ":" +
          ((now.getMinutes() < 10) ? "0" : "") + now.getMinutes() +
          //  ":" ((now.getSeconds() < 10) ? "0" : "") + now.getSeconds() +
          ((now.getHours() > 12) ? ('PM') : 'AM');
    },
    /********************* GESTIONE COOKIE **********************/
    areCookiesEnabled: function () {
      if(typeof Storage !== "undefined"){
        window.localStorage.setItem('EuInitLocalStorageConfigurationUI', 'done');
        if(window.localStorage.getItem('EuInitLocalStorageConfigurationUI') === 'done'){
          window.localStorage.removeItem('EuInitLocalStorageConfigurationUI');
          return true;
        }
      }
      return false;
    },

    getCookie: function (cname) {
      var value = window.localStorage.getItem(cname);
      if(value){
        this.debug && console.log("_getCookie: found " + cname + ": " + value);
        return value;
      }
      this.debug && console.log("_getCookie: " + cname + " not found");
      return "";
    },

    createCookie: function (name, value, days) {
      window.localStorage.setItem(name, value);
      this.debug && console.log("_createCookie: updated cookies -> " + window.localStorage.getItem(name));
    },

    eraseCookie: function (name) {
      window.localStorage.removeItem(name);
      this.debug && console.log("_createCookie: removec cookies -> " + name);
      //this.createCookie(name, "", -1);
    },

    createSessionCookie: function (prop, val) {
      if (!this.areCookiesEnabled()) return;

      if (!this.options.internal.cookie.obj)
        this.options.internal.cookie.obj = {};

      this.options.internal.cookie.obj[prop] = val;

      if (CryptoJS) {
        var string = CryptoJS.AES.encrypt(JSON.stringify(this.options.internal.cookie.obj), this.options.internal.cookie.options.secret);
        this.createCookie(this.options.internal.cookie.options.name, string, this.options.internal.cookie.options.validity);
      } else {
        this.createCookie(this.options.internal.cookie.options.name, JSON.stringify(this.options.internal.cookie.obj), this.options.internal.cookie.options.validity);
      }
    },

    eraseSessionCookies: function () {
      if (!this.areCookiesEnabled()) return;
      this.eraseCookie(this.options.internal.cookie.options.name);
    },

    getSessionCookie: function (prop) {
      this.logger(this.logLevel.INFO, "getSessionCookie passed");
      if (!this.areCookiesEnabled()) return;

      if (!this.options.internal.cookie.obj || this.isEmptyObject(this.options.internal.cookie.obj)) {
        if (this.getCookie(this.options.internal.cookie.options.name)) {
          if (CryptoJS) {
            var string = CryptoJS.AES.decrypt(this.getCookie(this.options.internal.cookie.options.name), this.options.internal.cookie.options.secret).toString(CryptoJS.enc.Utf8);
            if (string) {
              try {
                this.options.internal.cookie.obj = JSON.parse(string);
              } catch (err) {
                console.error(err);
                this.options.internal.cookie.obj = {};
              }
            }
          } else {
            this.options.internal.cookie.obj = JSON.parse(this.getCookie(this.options.internal.cookie.options.name));
          }
        } else {
          this.options.internal.cookie.obj = {};
        }
      }
      return this.options.internal.cookie.obj ? this.options.internal.cookie.obj[prop] : null;
    },

    isEmptyObject: function (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
          return false;
      }
      return true;
    },
    /************************************************************/
    appendSystemMsg: function (level, msg) { // level values: success,info,block,error		note: block means warning!!
      this.$emit("onSystemMsg", msg);
    },
    sendMessageToParent: function (msg) {
      if (window.parent && window.parent.postMessage) {
        window.parent.postMessage(msg, '*');
      }
    },
    setConfigMessages: function (confMessages) {
      if (confMessages.bye) {
        this.labelLang['bye'] = confMessages.bye;
      }
      if (confMessages.queue) {
        this.labelLang['queue'] = confMessages.queue;
      }
      if (confMessages.queueError) {
        this.labelLang['queueError'] = confMessages.queueError;
      }
      if (confMessages.queueTimeout) {
        this.labelLang['queueTimeout'] = confMessages.queueTimeout;
      }
      if (confMessages.welcome && !($.trim(confMessages.welcome) == '')) {
        this.labelLang['welcome'] = confMessages.welcome;
      } else {
        this.options.internal.writeWelcome = false
      }
      if (confMessages.serviceClosed) {
        this.labelLang['serviceClosed'] = confMessages.serviceClosed;
      }
    },
    configurationLoaded: function (e) {
      this.logger(this.logLevel.INFO, "configurationLoaded");
      var that = this;
      var conf = e.configuration;
      var confMessages = e.configuration.messages; // type messages

      if (confMessages) {
        this.setConfigMessages(confMessages);
      }

      if (conf.availableLicence && conf.channels) {
        var lic = conf.availableLicence;
        var chnl = conf.channels;
        if (this.options.configuration.loadConfigurationButton) {
          if (lic.hasOwnProperty('video') && lic.hasOwnProperty('video_minutes')) {
            this.options.configuration.allowVideoEscalation = this.parseBoolean(lic['video']) && this.parseBoolean(lic['video_minutes']) &&
              ($.inArray('video', $.map(chnl, function (val, key) {
                return val;
              })) > -1); // TODO change $.inArray
          }

          if (lic.hasOwnProperty('audio') && lic.hasOwnProperty('audio_minutes')) {
            this.options.configuration.allowAudioEscalation = this.parseBoolean(lic['audio']) &&
              this.parseBoolean(lic['audio_minutes']) &&
              ($.inArray('audio', $.map(chnl, function (val, key) {
                return val;
              })) > -1);
          }
          if (lic.hasOwnProperty('customerDocumentSharing')) {
            this.options.configuration.allowShareDoc = this.parseBoolean(lic['customerDocumentSharing']);
          } else {
            this.options.configuration.allowShareDoc = false;
          }

          this.options.configuration.allowShareScreen = false;
          if (this.parseBoolean(lic['customerScreenSharing'])) {
            if (!this.options.internal.webrtcScreenSharingEnabled) {
              //mostro il pulsante da customer gui quando:
              //non è abilitato screensharing webrtc
              this.options.configuration.allowShareScreen = true;
            }
            if (this.options.internal.webrtcScreenSharingType === 'disabled' || this.options.internal.webrtcScreenSharingType === 'extension') {
              //il caso di opera, non ha webrtc
              this.options.configuration.allowShareScreen = false;
            }

          }
        }
      }

      if (conf.initialForm) {
        this.typeForm = "initial";
        this.options.configuration.showInitialForm = conf.initialForm.enabled;
        if (this.options.configuration.showInitialForm && conf.initialForm.item) {
          this.options.configuration.formDefinition = conf.initialForm.item;
        }
      }

      if (conf.webcallback) {
        this.typeForm = "webcallback";
        this.options.configuration.enableWebCallback = conf.webcallback.enabled;
        if (this.options.configuration.enableWebCallback) {
          if (conf.webcallback.whenTrigger)
            this.options.configuration.whenTriggerWebCB = conf.webcallback.whenTrigger;
          if (conf.webcallback.item)
            this.options.configuration.callbackDefinition = conf.webcallback.item;
        }
      }

      if (conf.properties && conf.properties['session.maxStringSize']) {
        try {
          this.options.internal.maxAllowedMessageSize = parseInt(conf.properties['session.maxStringSize'], 10);
        } catch (e) { }
      }

      if (!this.options.internal.isinitialized) {
        this.setup();
      }

      this.options.internal.onlyWebCB = this.options.configuration.channel == 'webcallback' && $.inArray('webcallback', conf.channels) > -1;

      if (!this.options.internal.onlyWebCB) {
        this.options.internal.onlyWebCB = !($.inArray('audio', conf.channels) > -1 || $.inArray('video', conf.channels) > -1 || $.inArray('chat', conf.channels) > -1);
      }

      if (typeof conf.webrtcSupported !== 'undefined')
        this.options.internal.webrtcAvailable = conf.webrtcSupported;

      if (!this.options.internal.isSessionTransferError) {
        this.starting();
      } else {
        this.showSessionTransferError(e);
      }
    },
    setup: function () {
      try {
        if (this.options.internal.enabledGeoloc) {
          this.checkGeoLocation();
        }
      } catch (e) {
        this.logger(this.logLevel.INFO, "The user position may not have been acquired");
      }
      this.options.internal.isinitialized = true;
      return true;
    },
    checkIEBrowser: function () {
      ua = navigator.userAgent;
      /* MSIE used to detect old browsers and Trident used to newer ones*/
      var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
      return is_ie;
    },
    checkChromeBrowser: function () {
      var ua = navigator.userAgent;
      var is_chrome = ua.indexOf("Chrome") > -1;
      return is_chrome;
    },
    checkFirefoxBrowser: function () {
      var ua = navigator.userAgent;
      var is_firefox = ua.indexOf("Firefox") > -1;
      return is_firefox;
    },
    checkGeoLocation: function () {

      var locationOptions = {};

      if (this.options.internal.enabledGeoloc) {
        if (navigator.geolocation) {
          if (!this.checkChromeBrowser() && !this.checkFirefoxBrowser()) {
            locationOptions = {
              enableHighAccuracy: false,
              maximumAge: 50000
            };
          }

          navigator.geolocation.getCurrentPosition($.proxy(this.setCurrentPosition, this), $.proxy(this.errorCurrentPosition, this), locationOptions);
          this.options.internal.waitingGeoloc = true;
        } else {

          if (!this.checkChromeBrowser() && !this.checkFirefoxBrowser()) {

            locationOptions = {
              enableHighAccuracy: false,
              maximumAge: 50000
            };

            navigator.geolocation.getCurrentPosition($.proxy(this.setCurrentPosition, this), $.proxy(this.errorCurrentPosition, this), locationOptions);
            this.options.internal.waitingGeoloc = true;
          }
        }
      }
    },
    setCurrentPosition: function (position) {
      this.options.errorGeolation = null;
      this.options.supportGeolocation = true;

      this.options.internal.bridge.setGeolocation(position);
      this.options.pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      this.options.internal.waitingGeoloc = false;
    },
    errorCurrentPosition: function (error) {
      this.options.supportGeolocation = false;
      this.options.errorGeolation = error.message;
      this.options.internal.bridge.errorOnGeolocation(error);
      this.options.internal.waitingGeoloc = false;
    },

    showLoading: function (boolean, msg) {
      this.$emit("onShowLoading", boolean);
      this.$emit("onMsgLoading", msg);
    },
    callInitialForm: function () {
      this.logger(this.logLevel.INFO, "Show initial form");
      this.showLoading(false);
      this.$emit("onShowInitialForm", true);

    },
    skipInitialForm: function () {
      this.logger(this.logLevel.INFO, "hide initial form");
      this.$emit("onShowInitialForm", false);
      if (!this.options.internal.waitForPluginInstallation && !this.options.internal.isTransferred) {
        this.showLoading(true, this.labelLang.sessionCreating);
		setTimeout(function () {
        	this.askSession();
		}.bind(this), 5000);
      }

    },
    starting: function () {
      this.logger(this.logLevel.INFO, "starting");
      if (this.options.internal.haveAlreadySessionActive) {
        if (!this.options.internal.retrieveSession) {
          this.callAgent();
        }
      } else {
        if (this.options.configuration.showInitialForm && !this.options.internal.onlyWebCB) {
          this.callInitialForm();
        } else {
          this.skipInitialForm();
        }
      }



    },
    scrollToBottom: function () {
      // addded on chat component
    },
    agentError: function (e) {
      this.showAgentFailed(e, false);
    },

    responseWorkingHours: function (e) {
      this.options.internal.working_hours = e.working_hours_json;
      this.createWebCallBack(e);
    },
    showAgentFailed: function (e, transferred) {
      // If pass from here a close session not minimize chat;
      this.logger(this.logLevel.INFO, "Show Agent Faild");
      this.logger(this.logLevel.INFO, e);
      this.options.internal.isAgentError = true;
      if(e && e.service) {
        this.options.configuration.service = e.service;
      }
      this.$emit("restartTransferEnd", false);
      var m = this.messages || this.labelLang;

      if (e.reason == 'missingConfiguration') {
        this.showBlockingError(m.queueError);
        return;
      }

      if (e.reason == 'queueTimeout') {
        this.options.internal.bridge.requestWorkingHours(this.options.configuration.service, 8);
        return;
      }


      this.options.internal.bridge.requestWorkingHours(this.options.configuration.service, 8);
    },

    createWebCallBack: function (e) {
      if (e.olsonName)
        this.options.internal.olsonName = e.olsonName;
      if (e.timezone)
        this.options.internal.timezone = e.timezone;
      this.options.internal.agentErrorReason = e.reason;

      if (this.options.configuration.enableWebCallback) {
        this.buildWebCallBackHours(e);
        this.options.buttonCallBackVisible = true;
      } else {
        this.buildWebCallBackHours(e);
        this.options.buttonCallBackVisible = false;
      }


    },
    showBlockingError: function (msg) {
      this.$emit("onClassAllWidget");
      this.$emit("onError", msg);
      this.$emit("onShowLoading", false);
      this.$emit("onShowInitialForm", false);
      this.$emit("onWebCallBackForm", false);
      this.$emit("onshowWebcallbackHours", false);
      this.$emit("onshowWebcallbackHours", false);


    },
    showBlockingSuccess: function (msg) {
      this.$emit("onSuccess", msg);
      this.$emit("onShowLoading", false);
    },
    convertWH_XMLtoJSON: function () {
      // TODO convertWH_XMLtoJSON

    },
    createWorkingHoursAllDays: function () {
      var arrayWorkingHours = new Array();
      for (var i = 1; i < 8; i++) {
        var object = {
          dayofweek: i,
          start: "00:00",
          end: "23:59",
          enable: "true",
          message: null
        }
        arrayWorkingHours.push(object);
      }
      return arrayWorkingHours;
    },
    clearWhiteSpace: function (msg) {
      try {
        return msg.replace(/&nbsp;/g, ' ');
      } catch (error) {
        return msg;
      }
    },
    form: {
      isEmail: function (value) {
        value = value.trim();
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(value);
      },

      areEmails: function (value, separator, uuid, _self) {
        var error = false;

        var arvalue = value.split(separator);
        _self.internal.contacts[uuid].tmp = {};
        _self.internal.contacts[uuid].tmp.carbonCopy = '';
        for (key in arvalue) {
          var email = _self.trimString(arvalue[key]);
          if (!this.isEmail(email)) {
            error = true;
            _self.internal.contacts[uuid].tmp.carbonCopy = '';
            break;
          } else {
            _self.internal.contacts[uuid].tmp.carbonCopy += email + '|';
          }
        }
        if (error) return false;
        return true;
      },

      isDomain: function (domain) {
        var re = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/g;
        return re.test(domain.trim());
      },
      isIpDomain: function (domain) {
        var ipRe = /\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/;
        return ipRe.test(domain.trim());
      },

      isLinkMinify: function (link) {
        var re = /^bit\.ly\/[A-Za-z0-9_\-]*/g;
        return re.test(link.trim());
      },

      isUrl: function (url) {
        var urlRe = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
        return urlRe.test(url.trim());
      },

      isPhone: function (number) {
        var phoneRe = /^[0-9]{5,10}$/;
        return phoneRe.test(number.trim());
      },

      isValidExtension: function (namefile, arrayExt) {
        if (!namefile) {
          return false;
        }
        if (!arrayExt) {
          //uny.logger(logLevel.DEBUG, 'empty Array');
          return false;
        }
        var value = namefile.substr(namefile.lastIndexOf('.'));
        if ($.inArray(value, arrayExt) > -1) {
          return true;
        }
        return false;
      },

      isNumber: function (number) {
        if (typeof number == 'number')
          return true;
        return !(isNaN(number));
      }
    },
    isWebCallbackEnabled: function (reason) {
      var count = 0;
      for (var key in this.options.configuration.callbackDefinition) {
        count++;
        break;
      }
      switch (reason) {
        case "serviceClosed":
          reason = 'SERVICE_CLOSED';
          break;
        case "queueTimeout":
          reason = 'QUEUE_TIMEOUT';
          break;
        default:
          return this.options.configuration.enableWebCallback && count > 0;
      }
      return this.options.configuration.enableWebCallback && $.inArray(reason, this.options.configuration.whenTriggerWebCB) > -1 && count > 0;
    },

    showWebcallbackHours: function (e) {
      this.$emit("onshowWebcallbackHours", true); // show components chat
    },
    showWorkingHours: function (boolean) {
      // components working hours
      this.$emit("onShowWorkingHours", boolean);
    },
    showRecontactMe: function (boolean) {
      this.$emit("onShowRecontactMe", boolean);
    },
    showModalRetrieveAgentSessionClosed: function (boolean) {
      this.$emit('onRetrieveAgentSessionClosed', boolean);
    },
    closeAllView: function () {
      this.$emit('onDisableFooter', true);
      this.$emit('onDisableHeader', true);
      this.$emit('onShareDoc', false);
      this.$emit('onReserveEmail', false);
      this.$emit('onshowWebcallbackHours', false);
      this.$emit('onWebCallBackForm', false);
      this.$emit('onRetrieveAgentSessionClosed', false);
      this.$emit('onshowWebcallbackHours', false);
      this.$emit("onShowLoading", false);
      this.$emit("onShowInitialForm", false);
      this.$emit("onClassAllWidget");


		},
		closeSession: function (param) {
			var that = this;
			this.closeAllView();
			this.eraseSessionCookies();
			if(this.getUrlParam().type === "convy"){
				this.eraseCookie("UnycoChat_" + this.getUrlParam().version + "_" + this.getUrlParam().bot + "_" + this.getUrlParam().rnd);
			}else{
				this.eraseCookie("UnycoChat_" + this.getUrlParam().code + "_" + this.getUrlParam().rnd);
			}
			this.checkParams(param);

      setTimeout(function () {
        //COGITOSEARCH
        that.createSessionCookie(that.options.internal.cookie.props.cogitosearchstatus, that.options.CogitoSearchStatus.DESTROYED);
        that.createSessionCookie(that.options.internal.cookie.props.cogitourlopen, "");
        if (that.options.internal.haveAlreadySessionActive) {
          that.options.internal.bridge.closeSession(that.options.internal.skipRefresh);
        } else {
          if(that.getUrlParam().type === "convy"){
            localStorage.setItem("unycoFirstVisit_" + that.getUrlParam().version + "_" + that.getUrlParam().bot + "_" + that.getUrlParam().rnd, "true");
          }else{
            localStorage.setItem("unycoFirstVisit_" + that.getUrlParam().code + "_" + that.getUrlParam().rnd, "true");
          }
          that.sendMessageToParent({ command: that.options.ExternalCommands.COLLAPSE });
          that.sendMessageToParent({ command: that.options.ExternalCommands.REFRESHIFRAME });
          that.sendMessageToParent({ command: that.options.ExternalCommands.CLOSESESSION, isRefresh: that.options.internal.skipRefresh });
        }
        that.sendMessageToParent({ command: that.options.ExternalCommands.CLOSESESSION, isRefresh: that.options.internal.skipRefresh });
      }, 300);



    },
    sessionRestarted: function() {
      var that = this;
      this.closeAllView();
      that.sendMessageToParent({ command: that.options.ExternalCommands.COLLAPSE });
      that.sendMessageToParent({ command: that.options.ExternalCommands.REFRESHIFRAME });
    },

    checkParams: function(param) {
      if(param && param.hasOwnProperty('skipRefresh')) {
        this.options.internal.skipRefresh = param.skipRefresh;
      }else{
        this.options.internal.skipRefresh = false;
      }
    } ,
    handleIncomingScreenSharing: function () {
      // Deprecated from 5.0

    },
    sessionClosed: function (e) {
      //aggiungo questo if perchè se non ho la sessione è inutile che faccio due volte la sessionClosed,
      //supponendo che ci arrivo sempre, almeno una volta, con haveAlreadySessionActive a true
      if(!this.options.internal.haveAlreadySessionActive){
        return;
      }
      var that = this;
      this.logger(this.logLevel.INFO, "sessionClosed");
      this.options.internal.haveAlreadySessionActive = false;
      this.sendMessageToParent({ command: this.options.ExternalCommands.NOTACTIVECHAT });

      clearTimeout(this.options.internal.sessionRequestTimer);
      if (!this.options.internal.requestCloseFromCustomer) {

        if (this.options.internal.activeContact) {
          this.options.internal.bridge.closeContact();
          this.contactClosed();
        }

        switch (e.reason) {
          case 'customer':
            break;
          case 'system':
          case 'agent':
          case 'reroute':
          case 'reroute_on_rona':
          case 'reroute_on_reject':
          case 'reroute_on_logout':
          case 'reroute_on_agent_transfer':
          case 'reroute_on_service_transfer':
          default:
            this.showBlockingError(this.labelLang.genericError);
            break;
        }

      } else {
        // close From Agent;
        this.showBlockingSuccess(this.labelLang.bye);
      }

      if(this.options.internal.isConvy == false) {
        this.closeCobrowsing();
      }


			setTimeout(function () {
				if(!that.options.internal.skipRefresh) {
					if(that.getUrlParam().type === "convy"){
						localStorage.setItem("unycoFirstVisit_" + that.getUrlParam().version + "_" + that.getUrlParam().bot + "_" + that.getUrlParam().rnd, "true");
					}else{
						localStorage.setItem("unycoFirstVisit_" + that.getUrlParam().code + "_" + that.getUrlParam().rnd, "true");
					}
					that.sendMessageToParent({command: that.options.ExternalCommands.COLLAPSE});
					that.sendMessageToParent({command: that.options.ExternalCommands.REFRESHIFRAME});
					that.sendMessageToParent({command: that.options.ExternalCommands.CLOSESESSION, isRefresh: that.options.internal.skipRefresh});
				}else {
					that.options.internal.skipRefresh = false;
				}
			}, 2500);

    },
    contactClosed: function (e) {
      if (typeof e != typeof undefined) {
        this.$emit('onCloseChat', e);
      }

      this.$emit('onDisableFooter', true);
      this.$emit('onDisableHeader', true);

      this.sendMessageToParent({ command: this.options.ExternalCommands.NOTACTIVECHAT });
      this.options.internal.waitForAskSession = true;
      if(this.options.internal.isConvy == false) {
        this.closeCobrowsing();
      }
    },
    sessionDenied: function (e) {
      this.logger(this.logLevel.INFO, "sessionDenied");
      clearTimeout(this.options.internal.sessionRequestTimer);
      try {
        switch (e.reason) {
          case 'noLicence': //Usato quando non ci sono lic
            this.showBlockingError(this.labelLang.outofservice);
            break;
          case 'authenticationError': //Usato quando l'autenticazione va in errore (parametri inconsistenti, ws non raggiungibile)
          case 'authenticationFailed': //Usato quando l'autenticazione fallisce
          default:
            this.showBlockingError(this.labelLang.initError);
            break;
        }
      } catch (e) { }
    },
    requestServiceConfiguration: function () {
      this.options.configuration.service = this.getUrlParam().code; // TODO service param
      this.options.internal.bridge.loadServiceConfiguration(this.options.configuration.service); // after configurationLoaded
      this.createSessionCookie(this.options.internal.cookie.props.channel, this.options.configuration.channel);

    },
    sessionExpired: function (e) {
      this.logger(this.logLevel.INFO, "sessionExpired:");
      /*
        se ricevo un session expired vuol dire che la sessione è scaduta per timeout
        vuol dire che non devo riaprire la chat, quindi, prima ancora che questa si apre io faccio un
        refresh per sistemare al 100% la chat, in modo tale che sia pronta per iniziare una nuova
        conversazione solo al click sul bottone.
      */
      this.sendMessageToParent({ command: this.options.ExternalCommands.REFRESHIFRAME });
      return;
      /*
      !in teoria può essere eliminato, ma meglio ternerlo per un po' 02/09/2019
      if (this.options.internal.retrieveSession) {
        this.options.internal.haveAlreadySessionActive = false;
        this.options.internal.waitForAskSession = false;
        this.requestServiceConfiguration();

      }
      */
    },
    sessionQueueing: function (e) {
      this.options.configuration.initialForm == false;
      this.configurationLoaded(e);
      this.sessionCreated();
    },
    sessionTrasfering: function (e) {
      this.logger(this.logLevel.INFO, 'transferring:' + e.status.transferring);
      this.sendMessageToParent({ command: this.options.ExternalCommands.ACTIVECHAT });
      this.configurationLoaded(e);
      this.options.configuration.service = e.service;
      this.options.configuration.channel = e.channel;
      this.options.internal.history.messages = e.history;
      if(this.options.internal.isConvy == false) {
        this.closeCobrowsing();
      }
      this.sessionTransferStart(e);
      this.getEmailReserved(e);
      this.getHistory(e);
    },
    sessionFailed: function (status) {
      this.logger(this.logLevel.INFO, 'requestFailed:' + status);
    },
    sessionNoAgent: function (e) {
      this.logger(this.logLevel.INFO, 'Session no Agent');
      this.options.internal.minimizeOnCloseSession = false;
      //XXX multitab: ho tolto la chiusura perchè in multitab se premo "restart" sul primo tab
      //il secondo entra in questo metodo e mi chiude tutto. Ora invece torna in coda
      this.$emit("onShowLoading", true);
      this.sessionQueueing(e);
      //this.closeSession();
      //this.retrieveAgentSessionClosed();
      //XXX multitab: fine
    },
    sessionWithAgent: function (e) {
      this.sendMessageToParent({ command: this.options.ExternalCommands.ACTIVECHAT });
      this.options.configuration.service = this.getUrlParam().code;
      this.configurationLoaded(e);
      this.options.internal.haveAlreadySessionActive = true;
      this.options.configuration.service = e.service;
      this.options.configuration.channel = e.channel;
      this.options.internal.agentDisplayName = e.agentDisplayName; // TODO pass agent name
      this.$emit("onAgentDisplay", this.options.internal.agentDisplayName);
      this.options.internal.history.messages = e.history;
      this.getEmailReserved(e);
      this.getHistory(e);
      this.retrieveSessionStatus(e);
      this.agentSelected(e);
      clearTimeout(this.options.internal.sessionRequestTimer);
      this.enableShareDocButton();
      this.$emit("onComposingAgent", false);
    },
    setAgentType: function(e){
      if (e.realAgent) {
        this.options.rainbowHeader = false;
        this.options.imgAgent = '../img/support.svg';
        this.options.isVirtualAgent = false;
      } else {
        if (e.virtualAgent || this.getUrlParam().type === "convy") {
          this.options.isVirtualAgent = true;
        } else {
          this.options.isVirtualAgent = false;
        }
      }
    },
    sessionRetrieved: function (e) {
      /* Il controllo sullo stato della chat lo faccio qui in quanto
      lo devo fare se e solo se arrivo da un session retrieve.
      Se vado per un session expired allora la chat non si deve
      nemmeno aprire. */
      this.setAgentType(e);
      var chatstatus = this.getSessionCookie(this.options.internal.cookie.props.popoverstatus);
      if (this.isPopoverMode() && chatstatus == this.options.PopoverStatus.EXPANDED) {
        this.sendMessageToParent({ command: this.options.ExternalCommands.EXPAND });
        //COGITOSEARCH
        this.checkCogitoSearchIframe();
      }
      this.logger(this.logLevel.INFO, "sessionRetrieved");
      this.options.internal.endChat = false;
      this.options.internal.writeWelcome = false;
      this.options.configuration.service = this.getUrlParam().code; // TODO rework
      this.options.internal.haveAlreadySessionActive = true;
      this.options.internal.history.messages = e.history;
      this.$emit("onHistoryReceived", this.options.internal.history.messages);
      bus.$emit('showRestartButton', true);

      if (this.parseBoolean(e.status.queueing) === true) {
        this.logger(this.logLevel.INFO, "queueing");
        //XXX multitab: Questi emit per la grafica sono stati messi perchè le schede oltre la prima
        //mentre sono in "queue" avevano lo sfondo grigio
        this.$emit("onShowInitialForm", true);
        bus.$emit('hideInitialForm');
        this.$emit("onShowLoading", true);
        //XXX multitab: fine
        this.sessionQueueing(e);
        return;
      }
      if (this.parseBoolean(e.status.transferring) === true) {
        this.logger(this.logLevel.INFO, "transferring");
        this.sessionTrasfering(e);
        return;

      }
      if (this.parseBoolean(e.status.requestFailed) === true) {
        this.logger(this.logLevel.INFO, "requestFailed");
        this.sessionFailed(e.status.requestFailed);
      }

      //if (e.agentDisplayName == null && e.agentid == null) {
      //	this.logger(this.logLevel.INFO, "sessionNoAgent");
      //	this.callAgent();
      //}

      if (e.agentDisplayName == null && e.agentid == null) {
        this.logger(this.logLevel.INFO, "sessionNoAgent");
        this.sessionNoAgent(e);
      } else {
        this.logger(this.logLevel.INFO, "sessionWithAgent");
        this.sessionWithAgent(e);
      }
      if (this.parseBoolean(e.status.transferred) === true) {
        this.logger(this.logLevel.INFO, 'transferred:' + e.status.transferred);
        this.logger(this.logLevel.INFO, "Transfer end");
      }
    },
    getEmailReserved: function (args) {
      if (args.emailReserved) {
        // TODO getEmailReserved
        // $('.email-reserved').removeClass('hide'); // email-reserved hide
        // $('#emailModal').modal('hide'); // emailModal hide
      }
    },
    sessionTransferStart: function (e) {
      this.logger(this.logLevel.INFO, "sessionTransferStart");
      this.options.internal.waitingAgent = false;
      this.options.internal.isTransferring = true;
      clearTimeout(this.options.internal.timeoutCloseCall);
      if(this.options.internal.isConvy == false) {
        this.closeCobrowsing();
      }
      if (e.transferType == 'logout') {
        this.showTransferring(this.labelLang.sessionTransferringForLogout);
      } else {
        this.showTransferring(this.labelLang.sessionTransferring);
      }

    },
    showTransferring: function (msg) {
      //dovrebbe risolvere i messaggi invertiti per GLO??
      setTimeout(function() {
        this.$emit('onTrasfering', msg);
      }.bind(this), 1500);
    },
    clearFlags: function() {
      this.options.internal.agentDisplayName = false;
      this.options.internal.activeContact = false;
      this.options.internal.sessionRequestTimer = null;
      this.options.internal.olsonName = "";
      this.options.internal.timezone = "";
      this.options.internal.writeWelcome = false;
      this.options.internal.isAgentError = false;
      this.options.internal.isSessionTransferError = false;
      this.options.internal.working_hours = [];
      this.options.internal.retrieveSession = false;
      this.options.internal.waitForAskSession = false;
    },
    askSession: function (data, restart) {
      this.logger(this.logLevel.INFO, "askSession");

      if (!data) data = {};
      if (this.options.configuration.customAttachedData) {
        $.extend(data, this.options.configuration.customAttachedData);
      }

      $.extend(data, this.getUrlParam());

      if (!data.userCoords && this.options.pos && this.options.pos.lng) {
        this.options.internal.bridge.setGeolocation({
          coords: {
            longitude: this.options.pos.lng,
            latitude: this.options.pos.lat
          }
        });
      }

      delete data.debug;

      //change: sarà da settare come parametro esterno alle customerinfo
      data.initialChannel = this.options.configuration.channel;
      if(this.firstService){
        this.options.configuration.service = this.firstService;
      }else {
        this.firstService = this.options.configuration.service;
      }
      if (!this.options.internal.waitingGeoloc || this.options.internal.isConvy) {
        if(restart){
          //devo andare a riprendermi il codice del servizio dai parametri per ripartire dall'inizio
          this.options.configuration.service = this.getUrlParam().code;
          //se ricomincio una nuova sessione azzero il fatto di aver fatto un trasferimento
          this.clearFlags();
          this.options.internal.writeWelcome = true;
          this.options.internal.isTransferred = false;
          this.options.internal.bridge.restartSession(this.options.configuration.service, data);
        }else{
          this.options.internal.bridge.createSession(this.options.configuration.service, data);
        }
      }else {
        setTimeout($.proxy(function () {
          if(restart){
            //devo andare a riprendermi il codice del servizio dai parametri per ripartire dall'inizio
            this.options.configuration.service = this.getUrlParam().code;
            //se ricomincio una nuova sessione azzero il fatto di aver fatto un trasferimento
            this.clearFlags();
            this.options.internal.isTransferred = false;
            this.options.internal.writeWelcome = true;
            this.options.internal.bridge.restartSession(this.options.configuration.service, data);
          }else{
            this.options.internal.bridge.createSession(this.options.configuration.service, data);
          }
        }, this), this.options.internal.geolocTimeout);
      }
      this.options.internal.sessionRequestTimer = setTimeout($.proxy(function () {
        this.showBlockingError(this.labelLang.initError);
      }, this), this.options.internal.sessionRequestTimeout);

      this.options.internal.sessionData = data;
    },
    sendEvent: function (eventName, parameters) {
      if (this.options.internal.bridge && this.options.internal.bridge.sendChatEvent) {
        this.options.internal.bridge.sendChatEvent({
          eventName: eventName,
          parameters: parameters
        });
      }
    },
    retrieveAgentSessionClosed: function (e) {
      this.buildRetrieveAgentSessionClosed(true);
    },
    getHistory: function (args) {
      this.options.internal.history.config.skipScrollMessage = true;
      this.retrieveHistory(args.history, this.options.internal.history.config.rangeMessageToLoad, false);
      this.options.internal.history.config.skipScrollMessage = false;
      this.scrollToBottom();
    },
    retrieveSessionStatus: function (e) {
      if (e.status.paused)
        this.sessionPaused('');
    },
    retrieveHistory: function (history, limit, prepend, keepdiv) {
      // Raplace in component chat from 5.0;
    },
    sessionPaused: function (e) {
      this.$emit("onPause", this.labelLang.sessionPaused);
      this.options.inPause = true;
      if(this.options.internal.isConvy == false) {
        this.pauseCobrowsing();
      }
    },
    sessionResumed: function (e) {
      this.$emit("onResume", this.labelLang.sessionResumed);
      this.options.inPause = false;
      if(this.options.internal.isConvy == false) {
        this.resumeCobrowsing();
      }
    },
    buildAudio: function () {
      this.logger(this.logLevel.INFO, "build Audio");
      this.$emit("onShowInitialForm", false);
      this.$emit("onShowTools", true);
      this.$emit("onShowLoading", false);
      this.$emit("onAudioShow", true);
      this.$emit("onShowHeader", (!this.getUrlParam().channel || this.getUrlParam().channel == "chat"));
      this.options.isChatOnlyAudio = (this.getUrlParam().channel == "audio");

      this.options.internal.bridge.escalationRequest(this.options.configuration.channel, false); // if OK call escalationResult
    },
    buildVideo: function () {
      this.logger(this.logLevel.INFO, "build Video");
      this.$emit("onShowInitialForm", false);
      this.$emit("onShowTools", true);
      this.$emit("onShowLoading", false);
      this.$emit("onVideoShow", true);
      this.$emit("onShowHeader", (!this.getUrlParam().channel || this.getUrlParam().channel == "chat"));
      this.options.isChatOnlyVideo = (this.getUrlParam().channel == "video");

      this.options.internal.bridge.escalationRequest(this.options.configuration.channel, false); // if OK call escalationResult
    },
    buildChat: function () {
      this.logger(this.logLevel.INFO, "build Chat");
      this.$emit("onShowInitialForm", false);
      this.$emit("onShowHeader", true); // show components header
      this.$emit("onShowInput", true);
      this.$emit("onShowTools", true);
      this.$emit("onShowLoading", false);
      this.$emit("onShowChat", true); // show components chat

    },

    restartChat: function () {
      this.logger(this.logLevel.INFO, "restart Chat");
      this.$emit("onShowInitialForm", false);
      this.$emit("onShowHeader", false); // show components header
      this.$emit("onShowInput", false);
      this.$emit("onShowTools", false);
      this.$emit("onShowLoading", true);
      this.$emit("onShowChat", false); // show components chat

    },
    buildWebCallBackHours: function (e) {
      this.logger(this.logLevel.INFO, "build webCallBackHours" + e);
      this.$emit("onShowInitialForm", false);
      this.$emit("onShowChat", false);
      this.$emit("onShowHeader", false); // show components header
      this.$emit("onShowInput", false); // show components header
      this.$emit("onShowLoading", false);
      this.showWebcallbackHours(e); // send onshowWebcallbackHours event and onSetTextWebcallback event
    },
    buildWorkingHours: function (boolean) {
      this.logger(this.logLevel.INFO, "build WorkingHours");
      this.$emit("onShowInitialForm", false);
      this.$emit("onShowChat", false);
      this.$emit("onShowHeader", true); // show components header
      this.$emit("onShowLoading", false);
      this.showWorkingHours(boolean);
    },
    buildRecontactMe: function (boolean) {
      this.logger(this.logLevel.INFO, "build RecontactMe");
      this.$emit("onShowInitialForm", false);
      this.$emit("onShowChat", false);
      this.$emit("onShowHeader", true); // show components header
      this.$emit("onShowLoading", false);
      this.showRecontactMe(boolean);
    },
    buildRetrieveAgentSessionClosed: function (boolean) {
      this.logger(this.logLevel.INFO, "build RetrieveAgentSessionClosed");
      this.$emit("onShowInitialForm", false);
      this.$emit("onShowChat", false);
      this.$emit("onShowLoading", false);

      this.showModalRetrieveAgentSessionClosed(boolean);
    },
    escalationRequest: function (channel, isEscalation) {
      if (isEscalation) {
        var msg = this.labelLang.connectionEstablishing.replace(/\[\?channel\?\]/g, channel); // TODO MESSAGE ESCALTION
        this.options.internal.escalationType = channel;
      }

      if (this.options.internal.bridge.hasOwnProperty("getGatewayParameters")) {
        var params = this.options.internal.bridge.getGatewayParameters();
        if (params.hasOwnProperty("isf2f")) {
          if (typeof params.isf2f === "boolean") {
            this.$emit("isF2F", params.isf2f);
          } else {
            if (params.isf2f == "false") {
              this.$emit("isF2F", false);
            } else {
              this.$emit("isF2F", true);
            }
          }
        }
      }

      this.options.internal.bridge.escalationRequest(channel); // if OK call escalationResult

    },
    escalationResult: function (e) {
      this.logger(this.logLevel.INFO, "escalationResult" + e);
      this.logger(this.logLevel.INFO, e);

      if (e.result == true) {
        this.options.configuration.channel = this.options.internal.escalationType;
        this.options.internal.bridge.initializeMediaObject('mediabox', this.options.configuration.channel, null, this.options.configuration.pathSwfCustom);
        setTimeout($.proxy(function () {
          this.options.internal.bridge.createCall('mediabox');
        }, this), 1000);
        this.logger(this.logLevel.INFO, "initializeMediaObject || type:" + this.options.configuration.channel);
      } else {
        this.logger(this.logLevel.INFO, "Start Escalation not succesful..");
        this.appendSystemMsg('info', this.labelLang.escalationError);
        this.resetCalling();
      }
    },
    buildTypeChannel: function (channel) {
      this.logger(this.logLevel.INFO, "buildTypeChannel:" + channel);

      if (channel == 'audio') {
        this.buildAudio();
      } else if (channel == 'video') {
        this.buildVideo();
        this.options.configuration.allowEmailReservation = false;
      } else {
        this.buildChat();
      }
    },
    agentSelected: function (e) {
      this.logger(this.logLevel.INFO, "agentSelected");
      this.options.internal.activeContact = true;

      if (e.channel == "audio" || e.channel == "video") {
        this.options.configuration.channel = "chat";
      }
      this.setAgentType(e);

      var capabilities = ((e.capabilities) ? e.capabilities : {});
      var hasAudio = capabilities.audio;
      var hasVideo = capabilities.video;
      this.options.internal.agentDisplayName = e.agentDisplayName;

      if (typeof e.webRTCEnabled != 'undefined' && e.webRTCEnabled != null) {
        this.options.internal.agentWebrtcAvailable = (this.options.internal.webrtcAvailable && e.webRTCEnabled);
      }
      if (e.realAgent && hasAudio) {
        this.options.configuration.allowAudioEscalation = true;
      } else {
        if (hasAudio && this.options.configuration.allowAudioEscalation) {
          this.options.configuration.allowAudioEscalation = true;
        } else {
          this.options.configuration.allowAudioEscalation = false;
        }
      }

      if (e.realAgent && hasVideo) {
        this.options.configuration.allowVideoEscalation = true;
      } else {
        if (hasVideo && this.options.configuration.allowVideoEscalation) {
          this.options.configuration.allowVideoEscalation = true;
        } else {
          this.options.configuration.allowVideoEscalation = false;
        }
      }
      if (this.options.internal.isMobile) {
        this.customInitForMobile();
      }

      var cookieChannel = this.getSessionCookie(this.options.internal.cookie.props.channel);
      if (cookieChannel == 'chat') {
        this.options.configuration.channel = 'chat';
      }

      // if in transfer no build chat
      if (!this.options.internal.isTransferred) {
        this.buildTypeChannel(this.options.configuration.channel);
      }
    },
    welcomeMessage: function (e) {
      if (this.options.internal.writeWelcome) {
        this.options.internal.writeWelcome = false;
        this.msgReceived(e);
      }
    },
    msgReceived: function (e) {
      var msg = e.message;
      this.$emit("onMsgReceived", msg);
    },
    userEventSent: function(e) {
      bus.$emit("newUserEventLS", e);
    },
    userMsgSent: function (e) {
      var msg = e.message;
      this.$emit("newMessageLS", msg);
    },

    blinkMessageReceived: function () {
      if (this.isPopoverMode()) {
        if (!this.options.internal.isExpand)
          this.sendMessageToParent({
            command: this.options.ExternalCommands.BLINK
          });
      }
    },
    chatStateChanged: function (e) {
      // $(this.configuration.isComposingSelector).toggleClass('hidden'); // TODO IS COMPOSING
      this.$emit("onComposingAgent", e.value);
    },
    createLink: function (msg) {
      var link = '';
      if (this.form.isDomain(msg) || this.form.isIpDomain(msg) || this.form.isUrl(msg)) {
        if (msg.indexOf("http") > -1 || msg.indexOf('https') > -1 || msg.indexOf('ftp') > -1)
          link = msg;
        else
          link = 'http://' + msg;
      } else {
        link = msg;
      }
      this.logger(logLevel.INFO, link);
      return link;
    },
    incomingLink: function (e) {
      this.$emit("onLinkIncomming", e.link);
    },
    incomingDocument: function (e) {
      if (e.contentType == 'BLOB' && e.fileName) {
        this.$emit("onDocumentIncomming", e.doc, e.fileName);
      } else {
        e.doc = this.sanitizeDocument(e.doc);
        this.$emit("onDocumentIncomming", e.doc);
      }
    },
    incomingScreenSharingAccepted: function () {
      if (!this.options.internal.agentScreenStopped) {
        var str = this.options.configuration.incomingScreenSharingTemplate.replace(/\[\?txt\?\]/, this.labelLang.incomingScreen);

        //	$(str).appendTo(this.configuration.historySelector);
        //	this.scrollToBottom();
      }
    },
    sanitizeDocument: function (x) {
      if (x) {
        var str = x.substring(0, x.indexOf('?') + 1);
        var xs = this.getUrlParam(x);
        for (var key in xs) {
          if (key == "filename") {
            str = str + key + '=' + encodeURIComponent(xs[key]) + '&';
          } else {
            str = str + key + '=' + xs[key] + '&';
          }
        }
        str = str.substring(0, str.length - 1);
        return str;
      }
      return x;
    },
    sessionTransferEnd: function (e) {
      this.options.internal.isTransferring = false;
      this.options.internal.isTransferred = true;
      this.logger(this.logLevel.INFO, "Transfer end");

      if (this.options.internal.startCallAfterTransfer) {
        this.options.internal.startCallAfterTransfer = false;
        this.escalationRequest(this.options.internal.escalationType);
        //this.escalationResult({result:true});
      }
      //dopo questo evento deve arrivare un request_agent_complete, che entra in AgentSelected() quindi riprendo come un flusso normalissimo

      if (e.configuration) {
        this.configurationLoaded(e);
      }

      this.buildTypeChannel(this.options.configuration.channel);
      //dovrebbe risolvere i messaggi invertiti per GLO??
      setTimeout(function() {
        this.$emit('onTrasferEnd', this.labelLang.sessionTransferred);
      }.bind(this), 1000);



    },
    sessionTransferError: function (e) {
      //entro in questo if solo se il channel delle options è rainbow cosi è retrocompatibile con tutto il resto
      if(e.options && e.options.channel === "rainbow"){
        //devo mandare un messaggio di errore del trasferimento
        this.appendSystemMsg('info', this.labelLang.agentFaildTransfer);
        //termino il trasferimento
        this.$emit("restartTransferEnd", true);
        //setto i flag che non è in trasferimento
        if (!this.options.internal.isTransferred)
          this.options.internal.isTransferred = false;
        this.options.internal.isTransferring = false;
        this.options.internal.startCallAfterTransfer = false;
      }else {
        if (this.options.configuration.service != e.service) {
          this.options.internal.isSessionTransferError = true;
          this.options.configuration.service = e.service;
          this.options.internal.bridge.loadServiceConfiguration(e.service);
        } else {
          this.showSessionTransferError(e);
        }
      }
    },

    showSessionTransferError: function (e) {
      var conf = e.configuration;
      if (conf && conf.webcallback) {
        this.options.configuration.enableWebCallback = conf.webcallback.enabled;
        if (this.options.configuration.enableWebCallback) {
          if (conf.webcallback.whenTrigger)
            this.options.configuration.whenTriggerWebCB = conf.webcallback.whenTrigger;
          if (conf.webcallback.item)
            this.options.configuration.callbackDefinition = conf.webcallback.item;
        }
      }

      this.showAgentFailed(e, false);
      if (!this.options.internal.isTransferred)
        this.options.internal.isTransferred = false;
      this.options.internal.isTransferring = false;
      this.options.internal.startCallAfterTransfer = false;
    },
    sessionError: function (e) {
      if (!this.options.internal.requestCloseFromCustomer) {
        this.logger(this.logLevel.INFO, "sessionError: " + e.type);
        this.options.internal.haveAlreadySessionActive = false;
        //this.showBlockingError(this.labelLang.genericError);
        switch (e.reason) {
          case "failToShareDoc":
            this.appendSystemMsg('info', this.labelLang.failToShareDoc);
            break;
          case "serverError":
            this.showBlockingError(e.message || this.labelLang.genericError);
            break;
          default:
            this.showBlockingError(this.labelLang.genericError);
        }
      }
    },

    showPanelMessage: function (msg) {
      this.$emit("onPanelMessage", msg);
      this.$emit("onShowLoading", false);

    },
    resetCalling: function (msg) {
      this.options.internal.callAlreadyInstanced = false;
      this.options.internal.isCalling = false;
      this.$emit('onVideoEscalation', false);
      this.$emit('onAudioEscalation', false);
      this.$emit('onEscalation', false);
      this.$emit('onRestartButtonVideoAudio', false);

      if (this.options.isChatOnlyAudio || this.options.isChatOnlyVideo) {
        // se la chat è solo video o audio mostro il messaggio nella finestra di error
        this.showPanelMessage(msg);
        this.options.internal.bridge.closeContact();
        if(this.options.internal.isConvy == false) {
          this.closeCobrowsing();
        }
      }
    },

    callEvent: function (e) {
      this.logger(this.logLevel.INFO, "CALL EVENT:" + e.value);
      var that = this;
      var noChannelChat = false;
      if (this.options.isChatOnlyAudio || this.options.isChatOnlyVideo) {
        noChannelChat = true
      }

      switch (e.value) {
        case 'CONNECTED':
          this.appendSystemMsg('info', this.labelLang.connection);
          this.options.internal.isCalling = true;
          break;
        case 'FAILED':
          if (noChannelChat) {
            that.resetCalling(this.labelLang.escalationError);
          } else {
            that.appendSystemMsg('info', this.labelLang.escalationError);
            that.resetCalling();
          }
          break;
        case 'DISCONNECTED':
          if (noChannelChat) {
            that.resetCalling(this.labelLang.disconnectionAudioVideo);
          } else {
            that.appendSystemMsg('info', this.labelLang.disconnection);
            that.resetCalling();
          }
          break;
        case 'DISCONNECTED_WITH_ERROR':
          if (noChannelChat) {
            that.resetCalling(this.labelLang.disconnectionwitherror);
          } else {
            that.appendSystemMsg('info', this.labelLang.disconnectionwitherror);
            that.resetCalling();
          }
          break;
        case 'FLASH_NOT_LOADED':
          that.escalationResult({
            result: false
          });
          that.resetCalling();
          break;
        case 'RESTART':
          that.options.internal.escalationType = e.channel;
          if (that.options.internal.isTransferring) {
            that.options.internal.startCallAfterTransfer = true;
          } else {
            that.options.internal.startCallAfterTransfer = false;
            that.escalationRequest(that.options.internal.escalationType);
          }
        default:
          break;
      }
    },
    recordingEvent: function (e) {
      this.logger(this.logLevel.INFO, "RECORDING EVENT ==> " + e.value);
      if (e.value == "START" || e.value == "RESUME") {
        this.$emit('onRecording', true);
      } else {
        this.$emit('onRecording', false);
      }
    },
    downgradeToAudioDone: function () {
      this.options.internal.escalationType = 'audio';
    },

    handleIncomingScreenSharing: function (e) {
      // TODO handleIncomingScreenSharing
    },
    documentSent: function (prepend) {
      this.appendSystemMsg('info', this.labelLang.shareDocDone, null, prepend); // TODO send message
      if (prepend.contentType == 'BLOB' && e.fileName) {
        this.$emit("onDocumentSent", prepend.doc, prepend.fileName);
      } else {
        prepend.doc = this.sanitizeDocument(prepend.doc);
        this.$emit("onDocumentSent", prepend.doc);
      }
    },
    documentSendFailed: function () {
      this.appendSystemMsg('info', this.labelLang.shareDocFail);
    },
    documentSizeExceeded: function () {
      this.appendSystemMsg('info', this.labelLang.documentSizeExceeded);
      this.$emit('onMaxSizeFile')

    },
    documentExtensionNotAllowed: function () {
      this.appendSystemMsg('info', this.labelLang.extensionError);
    },
    disableShareDocButton: function () {
      if (!this.options.internal.agentDisplayName) {
        this.options.configuration.disableShareDoc = true;
        this.options.configuration.allowShareDoc = false;
      }
    },
    enableShareDocButton: function (e) {
      if(e && e.allowed_extensions && e.allowed_extensions.length != 0){
        this.options.internal.allowedExtensions = e.allowed_extensions
      }else{
        this.options.internal.allowedExtensions = null;
      }
      this.options.configuration.disableShareDoc = false;
      this.options.configuration.allowShareDoc = true;
      this.$emit('onDocEnable');

    },
    customCommandReceived: function (e) {
      try {
        var customCommand = JSON.parse(e.obj);
      } catch (err) {
        if (typeof e !== "undefined" && e.hasOwnProperty('obj'))
          customCommand = e.obj;
      }
      try {
        this.logger(this.logLevel.INFO, "Received Custom Command:" + customCommand.type + " with parameters " + (customCommand.parameters ? JSON.stringify(customCommand.parameters) : ""));
        try {
          if (!customCommand.type) {
            //GESTIRE COGITO SEARCH
            if(!customCommand.message && customCommand.eventName){
              //COGITOSEARCH
              var eventName = customCommand.eventName;
              var parameters = customCommand.parameters;
              switch(eventName){
                case "SHOW_SEARCH":
                  if(parameters && parameters.URL){
                    this.logger(this.logLevel.INFO, "Received command SHOW_SEARCH with url " + parameters.URL);
                    this.createSessionCookie(this.options.internal.cookie.props.cogitosearchstatus, this.options.CogitoSearchStatus.EXPANDED);
                    this.createSessionCookie(this.options.internal.cookie.props.cogitourlopen, parameters.URL);
                    this.sendMessageToParent({ command: this.options.ExternalCommands.COGITO_SEARCH, action: this.options.cogitoSearchAction.EXPAND, url: parameters.URL });
                  }else{
                    this.logger(this.logLevel.INFO, "Received command SHOW_SEARCH without parameters");
                  }
                  break;
                case "HIDE_SEARCH":
                  this.logger(this.logLevel.INFO, "Received command HIDE_SEARCH");
                  this.createSessionCookie(this.options.internal.cookie.props.cogitosearchstatus, this.options.CogitoSearchStatus.DESTROYED);
                  this.createSessionCookie(this.options.internal.cookie.props.cogitourlopen, "");
                  this.sendMessageToParent({ command: this.options.ExternalCommands.COGITO_SEARCH, action: this.options.cogitoSearchAction.HIDE});
                  break;
                case "SHOW_PAGE":
                  if(parameters && parameters.URL){
                    this.logger(this.logLevel.INFO, "Received command SHOW_PAGE with url " + parameters.URL);
                    this.sendMessageToParent({ command: this.options.ExternalCommands.COGITO_SEARCH, action: this.options.cogitoSearchAction.PAGE, url: parameters.URL });
                  }else{
                    this.logger(this.logLevel.INFO, "Received command SHOW_PAGE without parameters");
                  }
              }
            }else {
              customCommand = JSON.parse(customCommand.message);
            }
          } else {
            // GESTIRE QUI EVENTUALI CUSTOM COMMAND
            switch (customCommand.type) {
              case 'agent_made_screenshot':
                this.sendScreenshot(customCommand);
                break;
              default:
                this.logger(this.logLevel.ERROR, "Received enexpected Custom Command:" + customCommand.type);
                break;
            }
          }
        } catch (e1) {
          this.logger(this.logLevel.DEBUG, "Failed to handle custom command: " + e1.message + "\n" + e1.stack);
        }
      } catch (e2) {
        this.logger(this.logLevel.DEBUG, "Failed to handle custom command: " + e2.message + "\n" + e2.stack);
      }
    },

    sendScreenshot: function(command) {
      this.logger(this.logLevel.INFO, "Received Custom Command: "+JSON.stringify(command));
      this.$emit("onAgentSendScreenShot", "screenshot");
    },

    replaceMessagePlaceholders: function (e) {
      // TODO  replaceMessagePlaceholders
    },

    /******** START RAINBOW METHOD *********/
    rainbowEscalationRequest: function (channel, isEscalation) {
      if (isEscalation) {
        this.options.internal.escalationType = channel;
      }
      this.options.internal.bridge.rainbowEscalationRequest(channel);
    },

    rainbowWebrtcMessage: function (e) {
      switch (e.status) {
        case "incommingCall":
        case "active":
          this.$emit('onRainbowVideoEscalation', true);
          this.$emit('onEscalation', true);
          this.$emit('onRestartButtonVideoAudio', true);
          break;
        case "Unknown":
          this.$emit('onRainbowVideoEscalation', false);
          this.$emit('onEscalation', false);
          this.$emit('onRestartButtonVideoAudio', false);
          break;
      }
    },

    /******** END RAINBOW METHOD ***********/

    webrtc2sipHandler: function (event) {
      var options = null;
      if (event.options.hasOwnProperty("info_agent") && event.options.info_agent.length > 0) {
        options = event.options;
      } else {
        options = {
          "info_agent":
            [
              {
                "Remote-Party-ID": ""
              }
            ]
        };
      }
      if (event.type == EuBridge.EventType.call_ringing) {
        if (this.labelLang.hasOwnProperty("webrtc2siploading")) {
          options.info_agent[0]["Remote-Party-ID"] = this.labelLang.webrtc2siploading;
        } else {
          options.info_agent[0]["Remote-Party-ID"] = "Waiting for an agent...";
        }
        this.$emit('isRingingEvent', { "options": options });
      } else if (event.type == EuBridge.EventType.call_queued) {
        if (this.labelLang.hasOwnProperty("webrtc2siploading")) {
          options.info_agent[0]["Remote-Party-ID"] = this.labelLang.webrtc2siploading;
        } else {
          options.info_agent[0]["Remote-Party-ID"] = "Waiting for an agent...";
        }
        this.$emit('isQueuedEvent', { "options": options });
      } else if (event.type == EuBridge.EventType.call_running) {
        this.$emit('isRunningEvent', { "options": options });
      }
    }
  }
})

appUnyco.start()
